import { ApprovalConsiderationAnnounceFiveContainer } from '../../../containers/SupportSystem/ReportOnApprovalConsiderationResults/ApprovalConsiderationAnnounceFiveContainer';

export function ApprovalConsiderationAnnounceFivePage() {
    return (
        <ApprovalConsiderationAnnounceFiveContainer />
    )
}